module.exports = "<div ui-view=\"app\">\n\n  <div ui-view=\"overlay\" class=\"gsapify-router\"></div>\n\n  <div ui-view=\"content\" class=\"gsapify-router\"></div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/app.html
// module id = 135
// module chunks = 0